export default __webpack_public_path__ + "static/media/CheckMark.db33d26d.svg";